import React from "react";
import { Helmet } from "react-helmet";
import Button from "../components/ui/button";
import Logo from "../assets/qlogo.png";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans">
      <Helmet>
        <title>Questa | Create & Embed Surveys – MB-Techs</title>
        <meta
          name="description"
          content="Create custom surveys, embed them on your website, or host them with Questa by MB-Techs. No coding needed."
        />
        <meta
          name="keywords"
          content="survey builder, embed surveys, MB-Techs, Questa, online forms, polls, feedback tools"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="text-center py-20 px-4 bg-gradient-to-br from-black to-indigo-700 text-white">
        <div className="flex justify-center items-center">
          <div >
            <img src={Logo} alt="Questa Logo" />
          </div>
          <div>
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">
              Create. Embed. Discover Insights.
            </h1>
            <p className="text-lg sm:text-xl max-w-2xl mx-auto mb-6">
              Build stunning surveys in minutes. Embed them on your site or host
              them with us — no code needed.
            </p>
            <div className="space-x-4">
              <Button className="bg-white text-blue-700 hover:bg-gray-100 font-semibold">
                Start for Free
              </Button>
              <Button
                variant="outline"
                className="border-white text-white hover:bg-white hover:text-blue-700"
              >
                See How It Works
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Questa */}
      <section id="features" className="py-20 px-6 text-center max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4">
          Built for Creators, Marketers, and Teams
        </h2>
        <p className="text-lg mb-10">
          Drag & drop builder, instant embeds, and real-time analytics.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {[
            "Multiple input types (checkbox, radio, yes/no)",
            "Embed or host your survey",
            "Real-time response tracking",
            "Mobile-friendly designs",
            "Custom branding & themes",
            "CSV Export & public links",
          ].map((item, i) => (
            <div
              key={i}
              className="border p-6 rounded-2xl shadow hover:shadow-md transition"
            >
              <p className="font-medium">{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Live Preview */}
      <section id="preview" className="bg-gray-50 py-20 px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6">See It in Action</h2>
        <p className="text-lg mb-10 max-w-2xl mx-auto">
          Explore a live preview of how your surveys will look and work across
          all devices.
        </p>
        <div className="w-full max-w-4xl mx-auto border rounded-lg shadow-md bg-white">
          <div className="p-4 text-gray-600">
            [🔧 Live Preview or GIF Placeholder]
          </div>
        </div>
        <div className="mt-8">
          <Button className="bg-blue-700 text-white hover:bg-blue-800">
            Build My First Survey
          </Button>
        </div>
      </section>

      {/* Use Cases */}
      <section id="usecases" className="py-20 px-6 max-w-6xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold mb-6">Use Questa To…</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            "Collect post-purchase feedback",
            "Run internal HR/team surveys",
            "Gauge product interest with pre-launch polls",
            "Host public satisfaction surveys or quizzes",
          ].map((useCase, idx) => (
            <div
              key={idx}
              className="bg-gray-100 p-6 rounded-xl shadow hover:shadow-md"
            >
              <p className="font-medium text-lg">{useCase}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-blue-700 text-white py-20 text-center px-4">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4">
          Start Free. Upgrade When You're Ready.
        </h2>
        <p className="text-lg mb-6">
          No credit card required. Instant access to your first survey.
        </p>
        <Button className="bg-white text-blue-700 hover:bg-gray-100 font-semibold">
          Join Questa Now
        </Button>
      </section>

      {/* Footer */}
      <footer className="py-10 text-center text-sm text-gray-500">
        Questa™ © 2025 | {" "}
        <a href="#" className="underline">
          Privacy
        </a>{" "}
        | {" "}
        <a href="#" className="underline">
          Terms
        </a>
      </footer>
    </div>
  );
}
